<template>
  <div class="grid-view">
    <div class="main-content accounting-documents-rule">
      <div class="section operations">
        <div class="filters">
          <span v-if="!locked">
            <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
            <el-button type="primary" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
          </span>
          <span v-else>
            <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
            <el-button :disabled="!cellSelected" type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="primary" @click="refreshHandler">{{ $t('common.btn.refresh') }}</el-button>
            <el-button :disabled="!cellSelected" type="danger" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
          </span>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FinanceUtil from '@/utils/FinanceUtil'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { getLoading } from '@/utils/utilBaseElement'
import * as accountingDocumentsRuleApi from '@/api/financeManage/accountingDocumentsRule'

export default {
  name: 'VoucherGrouppingRule',
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      cellSelected: false, // 是否选中行
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor
        },
        onRowClicked: (event) => { this.cellSelected = true; this.selectedItem = event.data }
      },
      rowData: [],
      locked: true,
      selectedItem: null // 表格选中项
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_DataType'),
          field: 'businessDataType',
          width: 110,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.BIZ_DATA_TYPES),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: false,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.businessDataTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountingMethod'),
          field: 'accountingMode',
          width: 100,
          editable: params => {
            if (this.locked) return false
            const businessDataType = params.data.businessDataType
            return businessDataType === FinanceInterfaceConstants.INVOICE_RECEIVABLE.code ||
              businessDataType === FinanceInterfaceConstants.INVOICE_PAYABLE.code ||
              businessDataType === FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code ||
              businessDataType === FinanceInterfaceConstants.BILLING_RECEIVABLE.code ||
              businessDataType === FinanceInterfaceConstants.BILLING_PAYABLE.code ||
              businessDataType === FinanceInterfaceConstants.BILLING_OVERSEA.code
          },
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.ACCOUNTING_MODES),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: false,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.accountingModeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions1'),
          field: 'groupingDimension1',
          width: 120,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.groupingDimensionLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions2'),
          field: 'groupingDimension2',
          width: 120,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.groupingDimensionLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions3'),
          field: 'groupingDimension3',
          width: 120,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.groupingDimensionLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions4'),
          field: 'groupingDimension4',
          width: 120,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.groupingDimensionLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions5'),
          field: 'groupingDimension5',
          width: 120,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.groupingDimensionLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions6'),
          field: 'groupingDimension6',
          width: 120,
          editable: !this.locked,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: Array.from(FinanceInterfaceConstants.GROUPING_DIMENSIONS),
              tagName: this.$store.getters.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.groupingDimensionLabelFunc(params.value)
          }
        }
      ]
    }
  },
  created() {
    this.loadRules()
  },
  methods: {
    addHandler() {
      this.locked = false
      this.rowData.push({ waitDealStatus: 'add' })
      this.gridOptions.api.refreshCells({ force: true })
    },
    editHandler() {
      if (this.rowData && this.rowData.length > 0) {
        this.locked = false
      }
    },
    saveHandler() {
      const saveList = []
      for (const rule of this.rowData) {
        if (['add', 'edit'].includes(rule.waitDealStatus)) {
          saveList.push(rule)
        }
      }
      if (saveList.length) {
        // 校验
        for (const rule of saveList) {
          if (!rule.businessDataType) {
            this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectDataType'))
            return
          } else if (!rule.groupingDimension1) {
            this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectGroupingCondition'))
            return
          }
          if (!rule.uuid) {
            rule.accountSetUuid = this.accountSet.uuid
          }
          const businessDataType = rule.businessDataType
          if (businessDataType !== FinanceInterfaceConstants.INVOICE_RECEIVABLE.code &&
            businessDataType !== FinanceInterfaceConstants.INVOICE_PAYABLE.code &&
            businessDataType !== FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code &&
            businessDataType !== FinanceInterfaceConstants.BILLING_RECEIVABLE.code &&
            businessDataType !== FinanceInterfaceConstants.BILLING_PAYABLE.code &&
            businessDataType !== FinanceInterfaceConstants.BILLING_OVERSEA.code) {
            rule.accountingMode = FinanceInterfaceConstants.MODE_NORMAL.code
          }
        }
        // 保存
        const loading = getLoading()
        accountingDocumentsRuleApi.save(saveList).then(resp => {
          this.saveSuccess(resp)
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
      }
      this.locked = true
    },
    cancelHandler() {
      this.locked = true
      this.loadRules()
    },
    loadRules() {
      const loading = getLoading()
      const params = {}
      params.accountSetUuid = this.accountSet.uuid
      params.pageNum = 1
      params.pageSize = 100
      accountingDocumentsRuleApi.query(params).then(resp => {
        this.setDefaultValue(resp.data.list)
        this.rowData = resp.data.list
        this.gridOptions.api.refreshCells({ force: true })
        this.accountSet.accountingDocumentsRule = this.rowData
      }).finally(() => loading.close())
      this.gridOptions.api.clearFocusedCell()
      this.cellSelected = false
      this.selectedItem = null
    },
    refreshHandler() {
      this.loadRules()
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_STDTVGR'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        canCloseModule: true
      })
      const loading = getLoading()
      accountingDocumentsRuleApi.remove({ uuid: currentRow.uuid }).then(resp => {
        this.removeSuccess(currentRow.uuid)
      }).finally(() => loading.close())
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
    },
    saveSuccess(resp) {
      this.setDefaultValue(resp.data)
      // 返回的列表中可能同时含有编辑的和新增的数据
      const list = resp.data
      if (!list || list.length === 0) return
      // 1 遍历rowData列表能匹配到uuid的数据（编辑的数据），更新数据
      for (let i = 0; i < this.rowData.length; i++) {
        const row = this.rowData[i]
        if (row.uuid) {
          const index = list.findIndex(params => params.uuid === row.uuid)
          if (index > -1) {
            Object.assign(row, list[index])
            list.splice(index, 1)
          }
          row.waitDealStatus = ''
        }
      }
      // 2 遍历rowData列表中没有uuid的数据 删除该数据
      for (let i = this.rowData.length - 1; i >= 0; i--) {
        if (!this.rowData[i].uuid) {
          this.rowData.splice(i, 1)
        }
      }
      // 3 添加列表里没有匹配uuid的数据（新增的数据）到列表
      this.rowData.push(...list)
      this.gridOptions.api.refreshCells({ force: true })
      this.accountSet.accountingDocumentsRule = this.rowData
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
        this.accountSet.accountingDocumentsRule = this.rowData
      }
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    setDefaultValue(ruleList) {
      if (ruleList) {
        for (const rule of ruleList) {
          if (rule.groupingDimension1 === 0) rule.groupingDimension1 = ''
          if (rule.groupingDimension2 === 0) rule.groupingDimension2 = ''
          if (rule.groupingDimension3 === 0) rule.groupingDimension3 = ''
          if (rule.groupingDimension4 === 0) rule.groupingDimension4 = ''
          if (rule.groupingDimension5 === 0) rule.groupingDimension5 = ''
          if (rule.groupingDimension6 === 0) rule.groupingDimension6 = ''
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
